module.exports = (__webpack_require__(76))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webpack/buildin/global.js from dll-reference vendor
// module id = 66
// module chunks = 0